const AppConstant = {
  OrderType: {
    CONTRACT: 0,
    OPEN: 1,
    NO_FREIGHT: 2,
    MARKET: 3,
  },
  FreightType: {
    EX_WORKS: 0,
    PARTY_COLLECT: 1,
  },
  OrderTypes: {
    CONTRACTED: 'Contracted',
    OPEN: 'Open',
  },
};

export const FIELD_TYPES = {
  DATE: 'date',
  NUMBER: 'number',
  TEXTBOX: 'textbox',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  ATTACHMENT: 'attachment',
  SINGLE_SELECT: 'single_select',
  TEXT: 'text',
};

export default AppConstant;
